import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../Configurations/AuthContext';
import './UserDashboardSidebar.css';

const UserDashboardSidebar = () => {
    const { user, logout } = useAuth(); 

    const navLinks = [
       { path: '/my-profile', icon: 'ri-user-settings-line', label: 'My Profile' },
       { path: '/topup-request', icon: 'ri-wallet-line', label: 'Top Up Request' },
       { path: '/markup-setting', icon: 'ri-percent-line', label: 'MarkUp Setting'},
       { path: '/my-flightbookings', icon: 'ri-plane-line', label: 'Flight Bookings' },
       { path: '/my-hotelbookings', icon: 'ri-hotel-bed-line', label: 'Hotel Bookings' },
       { path: '/my-sightseeingbookings', icon: 'ri-earth-line', label: 'Sightseeing Bookings' },
       { path: '/my-busbookings', icon: 'ri-bus-line', label: 'Bus Bookings' },
       { path: '/flightreport', icon: 'ri-file-chart-line', label: 'Flight Booking Reports' },
       { path: '/hotelreport', icon: 'ri-bar-chart-box-line', label: 'Hotel Booking Reports' },
       { path: '/change-password', icon: 'ri-lock-password-line', label: 'Change Password'},
       { path: '/manage-branches', icon: 'ri-git-branch-line', label: 'Branches' },
       { path: '/manage-users', icon: 'ri-group-line', label: 'Users' },
       
    ];

    return (
        <aside className="user-dashboard-sidebar">
            <nav className="sidebar-nav">
                {navLinks.map((link) => (
                    <NavLink 
                        key={link.path} 
                        to={link.path} 
                        className="sidebar-link"
                    >
                        <i className={link.icon}></i>
                        <span>{link.label}</span>
                    </NavLink>
                ))}

                {/* Sign Out button remains at the end of the nav list */}
                <button onClick={logout} className="sidebar-link logout-btn">
                    <i className="ri-logout-box-r-line"></i>
                    <span>Sign Out</span>
                </button>
            </nav>
        </aside>
    );
};

export default UserDashboardSidebar;